module.exports = __webpack_public_path__ + "img/cursor-text.0921ae32.svg";